import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"background":"#eaeaea"},
  class: "mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxFormTable = _resolveComponent("TaxFormTable")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_UploadTaxFrom = _resolveComponent("UploadTaxFrom")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_TaxForm = _resolveComponent("TaxForm")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_window, {
      modelValue: _ctx.step,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_TaxFormTable, { onEditTaxFrom: _ctx.editTaxFrom }, null, 8, ["onEditTaxFrom"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_UploadTaxFrom, {
              onForms: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setForms($event))),
              onRouteBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step = 0))
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_back, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 0))
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "d-flex justify-center pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.displayTaxFromMode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.displayTaxFromMode) = $event)),
                      group: "",
                      shaped: "",
                      mandatory: "force"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          value: "TaxFormTable",
                          class: "mx-0"
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode(" Saisie ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          value: "TaxFormPng",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode(" Cerfa ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-flex justify-center align-center pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.millesim,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.millesim) = $event)),
                      items: _ctx.millesimItems,
                      outlined: "",
                      "hide-details": "",
                      label: "Choix du millésime",
                      style: {"width":"70%"},
                      density: "compact"
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.updateTaxFrom,
                      rounded: "",
                      class: "mx-2",
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.taxFormId ? "Mettre a jour" : "Ajouter"), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    (_ctx.displayTaxFrom)
                      ? (_openBlock(), _createBlock(_component_TaxForm, {
                          key: 0,
                          fieldsChild: _ctx.fields,
                          formInput: _ctx.forms.form,
                          rulesInput: _ctx.forms.rules,
                          valuesInput: _ctx.forms.values,
                          cerfaInput: _ctx.forms.cerfa,
                          imageInput: _ctx.forms.imageUrl,
                          activeTab: _ctx.displayTaxFromMode,
                          loaded: true
                        }, null, 8, ["fieldsChild", "formInput", "rulesInput", "valuesInput", "cerfaInput", "imageInput", "activeTab"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}